// extracted by mini-css-extract-plugin
var _1 = "_ohzcP";
var _2 = "_RXg3M";
export { _1 as "sortableHeaderCellRenderer", _2 as "sortingArrows" }
